import { createSelector } from 'reselect';

import type IState from 'types/Istore';

const selectUserBankDetails = (state: IState) => state.userBankDetails;

const selectActiveDepositPartner = createSelector(
  [selectUserBankDetails],
  ({ activeDepositPartner }) => activeDepositPartner
);

const selectEnabledDepositPartners = createSelector(
  [selectUserBankDetails],
  ({ enabledDepositPartners }) => enabledDepositPartners
);

export {
  selectUserBankDetails,
  selectActiveDepositPartner,
  selectEnabledDepositPartners,
};
